import React from 'react';
import { snakeToTitleCase } from '@/modules/shared/utils';
import { IGNORE_KEYS } from '../constants';
import type { GlobalSearchHit } from '../types';
import FieldValue from './FieldValue';

/** Generic key/value rows for a hit, hiding meta keys. */
const FieldList: React.FC<{ hit: GlobalSearchHit }> = ({ hit }) => {
  const keys = Object.keys(hit).filter((key) => !IGNORE_KEYS.includes(key));

  return (
    <dl className="space-y-1.5">
      {keys.map((key) => (
        <div key={key} className="flex gap-2 text-sm">
          <dt className="w-36 shrink-0 text-muted-foreground">{snakeToTitleCase(key)}</dt>
          <dd className="min-w-0 break-words text-foreground">
            <FieldValue hit={hit} fieldKey={key} />
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default FieldList;
